//Router React
import React, {useEffect} from 'react';
import { Route, Routes } from 'react-router-dom'
import Dashboard from './Screens/Dashboard';
import Login from './Screens/Login';
import NotFound from './Screens/NotFound';
import { auth } from './config/firebase';
import { useNavigate } from "react-router-dom";
import Register from './Screens/Register';
import { useLocation, redirect  } from 'react-router-dom';
import LoadingPage from './Screens/LoadingPage';
import Profile from './Screens/Profile';
import useAuth from './Hooks/useAuth';


const RouterApp = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, loading } = useAuth();

    if (loading) {
        <LoadingPage />
    }

    useEffect(() => {
        if (user) {
            if (location.pathname === "/") {
                redirect('/dashboard')
            }
        } else if (location.pathname === "/register") {
            redirect('/register')
        }
    }, [])

    return (
        <Routes>
            <Route index path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}

export default RouterApp;